// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3Y2dp","topBottomGutter":"Layout_topBottomGutter__12yoZ"};